import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import translations from '../../../../../text/get-started-translations.json';
import language from '../../../../../utils/LanguageSettings';

import styles from './STBIntroduction.module.scss';
import FeatureItem from './FeatureItem';

import tvBoxZh from "../../../../../images/get-started/tv-box-zh-mobile.png";
import tvBoxEn from "../../../../../images/get-started/tv-box-en-mobile.png";
import stbTvBoxZh from "../../../../../images/get-started/stb-tv-box-zh.png";
import stbTvBoxEn from "../../../../../images/get-started/stb-tv-box-en.png";
import installation from "../../../../../images/icon/installation.svg";
import lowerLatency from "../../../../../images/icon/lower-latency.svg";
import extraChannles from "../../../../../images/icon/extra-channels.svg";
import dedicatedLine from "../../../../../images/icon/Dedicated-Line.svg";
const STBIntroduction: React.FC = memo(() => {
  const pageTranslations = translations[language]; // Select the correct translations

  return (
    <div className={styles["stb-introduction"]}>
      <div className={styles["gradient-background"]}>
        <div className={styles["title"]}>
          <div className={styles["container"]}>
            <h2>{pageTranslations.BoostBox}</h2>
          </div>
        </div>
        <div className={styles["image"]}>
          <img src={language.indexOf('zh') > -1 ? tvBoxZh : tvBoxEn} alt="TV Box" className={styles["mobile"]} />
          <img src={language.indexOf('zh') > -1 ? stbTvBoxZh : stbTvBoxEn} alt="STB TV Box" className={styles["desktop"]} />
        </div>
      </div>
      <div className={`${styles["container"]} ${styles["features-wrapper"]}`}>
        <div className={styles["features"]}>
          <FeatureItem
            imageSrc={lowerLatency}
            title={pageTranslations.LowLatency}
          />
          <FeatureItem
            imageSrc={dedicatedLine}
            title={pageTranslations.ExtraStream}
            subtitle={pageTranslations.ConcurrentStreams}
          />
          <FeatureItem
            imageSrc={extraChannles}
            title={pageTranslations.MoreChannels}
          />
          <FeatureItem
            imageSrc={installation}
            title={pageTranslations.FreeInstallation}
          />
        </div>
        <div className={styles["cta-wrapper"]}>
          <Link to="https://www.nowtv.now.com/support/set-top-box-2/" target="_blank" rel="noreferrer noopener" className={"btn primary"}>
            {pageTranslations.LearnMore}
          </Link>
        </div>
      </div>
    </div>
  );
});

export default STBIntroduction;